import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import React from "react";
import {Tag} from "antd";

const ContactModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();

    columns.push({key:'id', width: 80, filter:true, sorter:true, title:<Trans>ID</Trans>});
    columns.push({
        key: 'type',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>DEPARTURE</Trans>,
                value: 'DEPARTURE',
            },
            {
                label: <Trans>ARRIVAL</Trans>,
                value: 'ARRIVAL',
            }
        ],
        sorter: true,
        width: 150,
        title: <Trans>Type</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'DEPARTURE') {
                color = 'green';
                transText = <Trans>DEPARTURE</Trans>;
            } else if (text === 'ARRIVAL') {
                color = 'blue';
                transText = <Trans>ARRIVAL</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });

    columns.push({key:'name', width: 300, filter:true, sorter:true, title:<Trans>Name of business or person</Trans>});
    columns.push({key:'postalAddress', width: 300, filter:true, sorter:true, title:<Trans>Postal Address</Trans>});
    columns.push({key:'emailAddress', width: 300, filter:true, sorter:true, title:<Trans>Email Address</Trans>});
    columns.push({key:'shippingAddress', width: 300, filter:true, sorter:true, title:<Trans>Shipping Address</Trans>});
    columns.push({key:'updatedDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, filter:true, sorter:true, title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 180, dateTimeFilter:true, sorter:true, title:<Trans>Created Date</Trans>, direction:"desc"});
    columns.push({key:'createdBy', width: 150, filter:true, sorter:true, title:<Trans>Created By</Trans>});

    return{
        columns:columns,
        url:"/resource/contacts"
    };

}
export default ContactModel();